/**
 * Returns a same-origin image URL. The Worker resizes the stored object.
 *
 * @param url - The original remote image URL on storage.googleapis.com
 * @param width - Desired image width in pixels
 */
export function imageUrl(url: string, width?: number): string {
	const params = new URLSearchParams({ url })
	if (width) params.set('w', String(width))
	return `/api/image?${params}`
}